export default __webpack_public_path__ + "static/media/intro.f7d1384b.jpg";